"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _SshKnownHost = _interopRequireDefault(require("../model/SshKnownHost"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* Ssh service.
* @module api/SshApi
* @version 0.4.1
*/
var SshApi = /*#__PURE__*/function () {
  /**
  * Constructs a new SshApi. 
  * @alias module:api/SshApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function SshApi(apiClient) {
    _classCallCheck(this, SshApi);

    this.apiClient = apiClient || _ApiClient.default.instance;
  }
  /**
   * Callback function to receive the result of the deleteSshKnownHost operation.
   * @callback module:api/SshApi~deleteSshKnownHostCallback
   * @param {String} error Error message, if any.
   * @param data This operation does not return a value.
   * @param {String} response The complete HTTP response.
   */

  /**
   * 删除单条记录的 SSH 主机
   * 通过 authorzied key 作为参数删除单条记录的 SSH 主机, 如果对应的 known host 不存在则直接返回 ok
   * @param {String} authorizedKey 
   * @param {module:api/SshApi~deleteSshKnownHostCallback} callback The callback function, accepting three arguments: error, data, response
   */


  _createClass(SshApi, [{
    key: "deleteSshKnownHost",
    value: function deleteSshKnownHost(authorizedKey, callback) {
      var postBody = authorizedKey; // verify the required parameter 'authorizedKey' is set

      if (authorizedKey === undefined || authorizedKey === null) {
        throw new Error("Missing the required parameter 'authorizedKey' when calling deleteSshKnownHost");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/ssh/known/host', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the deleteSshKnownHosts operation.
     * @callback module:api/SshApi~deleteSshKnownHostsCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 清空存储的 ssh known hosts
     * 清空存储的 ssh known hosts
     * @param {module:api/SshApi~deleteSshKnownHostsCallback} callback The callback function, accepting three arguments: error, data, response
     */

  }, {
    key: "deleteSshKnownHosts",
    value: function deleteSshKnownHosts(callback) {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/ssh/known/hosts', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getSshKnownHosts operation.
     * @callback module:api/SshApi~getSshKnownHostsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/SshKnownHost>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 获取所有的 ssh known hosts
     * 获取所有的 ssh known hosts
     * @param {module:api/SshApi~getSshKnownHostsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/SshKnownHost>}
     */

  }, {
    key: "getSshKnownHosts",
    value: function getSshKnownHosts(callback) {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_SshKnownHost.default];
      return this.apiClient.callApi('/ssh/known/hosts', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the postSshKnownHost operation.
     * @callback module:api/SshApi~postSshKnownHostCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 提交一个主机记录到 ssh known hosts
     * 提交一个主机记录到 ssh known hosts, 如果主机已存在则覆盖, 如果不存在则创建
     * @param {module:model/SshKnownHost} sshKnownHost 
     * @param {module:api/SshApi~postSshKnownHostCallback} callback The callback function, accepting three arguments: error, data, response
     */

  }, {
    key: "postSshKnownHost",
    value: function postSshKnownHost(sshKnownHost, callback) {
      var postBody = sshKnownHost; // verify the required parameter 'sshKnownHost' is set

      if (sshKnownHost === undefined || sshKnownHost === null) {
        throw new Error("Missing the required parameter 'sshKnownHost' when calling postSshKnownHost");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/ssh/known/host', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the postSshKnownHosts operation.
     * @callback module:api/SshApi~postSshKnownHostsCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 导入多条 ssh known host
     * 根据非覆盖的原则, 根据 ssh known hosts 文本导入多条 ssh known host, 一般用于导入 ~/.ssh/known_hosts 文件, 如果公钥已存在则只添加主机
     * @param {String} knownHosts ssh known hosts 字符串文本, 例如 ~/.ssh/known_hosts 整个文件的内容
     * @param {module:api/SshApi~postSshKnownHostsCallback} callback The callback function, accepting three arguments: error, data, response
     */

  }, {
    key: "postSshKnownHosts",
    value: function postSshKnownHosts(knownHosts, callback) {
      var postBody = knownHosts; // verify the required parameter 'knownHosts' is set

      if (knownHosts === undefined || knownHosts === null) {
        throw new Error("Missing the required parameter 'knownHosts' when calling postSshKnownHosts");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/ssh/known/hosts', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
  }]);

  return SshApi;
}();

exports.default = SshApi;